import { SafetyAlertType } from '@casops/store/apis/commonModels';
import { SafetyAlertModel } from '@casops/store/apis/personnelSafetyApi';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import styles from './SafetyAlertTitle.module.scss';
import classNames from 'classnames';

interface SafetyAlertTitleProps {
  model?: SafetyAlertModel;
}

export const SafetyAlertTitle = ({ model }: SafetyAlertTitleProps): ReactElement => {
  const { t } = useTranslation();

  if (typeof model !== 'undefined') {
    const isActive = !model.ack;
    const title =
      model.typ === SafetyAlertType.Duress
        ? t('Model.Name.SafetyAlertDuress')
        : t('Model.Name.SafetyAlertManDown');

    return (
      <div className={classNames(styles.title, isActive && styles['title--active'])}>{title}</div>
    );
  }

  return <Skeleton width={250} />;
};
